import apiFactory from '../apiFatory';

export default apiFactory(
  'User',
  [
    'ajaxGenSecretKey',
    'ajaxIsLogin',
    'checkLogin',
    'getAccountValidateImage',
    'getPhoneVerificationCode',
    'ajaxIsNeedImageVerificationCode',
    'ajaxWechatLoginQrcode', // 获取微信登录二维码信息
    'ajaxBindUserLoginCredentials',//微信账号绑定winit账号
    'ajaxCustomerTypeMap',//获取客户类型
    'ajaxFirstStepRegister',//注册第一步表单验证
    'ajaxUserMailRegister',//注册表单提交
    'logout',//登出
    'changeAccount',//变更账号
    'validateLoginPassword',//验证密码
    'bindUserLoginCredentials', //用于个人中心微信绑定，微信绑定万邑联账户（参数密文传送）
    // 'checkWeChatAccountBinding', //用于个人中心微信绑定，检查微信是否已经绑定了其他万邑联账户（参数密文传送）
    'refreshCustomerInfo',//变更资料信息后，重刷session里的customerInfo
    'ajaxGetRoleElements', // 获取页面元素
    'ajaxCheckLoginCredentialsBind',//获取微信绑定校验值
    'ajaxQueryCredentialsBindUserInfoList', // 获取绑定的账号
  ]
);
